import { makeHttpRequest } from "@/shared";

export const deleteAdditionalServices = async (ids) => {
    const response = (
        await makeHttpRequest({
            url: "/service/additional/delete-multiple",
            method: "DELETE",
            params: { items: ids },
        })
    ).data;

    return response;
};
